import { getDefautlVoiceForExpressiveAvatar } from '@/pages/AdvancedEditor/utils/expressive-utils';
import { DEFAULT_FEMALE_VOICE, DEFAULT_MALE_VOICE, DEFAULT_VOICE } from '@/state/presenters';
import { IVoice, Presenter, Providers } from '@d-id/types';

export const getDefaultVoiceForPresenter = (presenter: Pick<Presenter, 'voice' | 'gender' | 'voice_id'> | undefined, voices: IVoice[]) => {
    let defaultPresenterVoice: IVoice | undefined =
        getDefautlVoiceForExpressiveAvatar(presenter as Presenter) ||
        (presenter && voices.find(voice => voice.id === presenter.voice_id)) ||
        (presenter?.voice && voices.find(voice => voice.id === presenter.voice?.voice_id));

    if (defaultPresenterVoice?.provider === Providers.Elevenlabs) {
        defaultPresenterVoice = { ...defaultPresenterVoice, language: 'multilingual' };
    }

    return defaultPresenterVoice;
};

export const getDefaultVoiceForGender = (gender: string | undefined, voices: IVoice[]) => {
    const language = DEFAULT_VOICE.language;
    const defaultVoiceByGender = gender === 'male' ? DEFAULT_MALE_VOICE : DEFAULT_FEMALE_VOICE;

    return (
        voices.find(voice => voice.language === language && voice.id === defaultVoiceByGender) ||
        voices.find(voice => voice.language === language && voice.gender === gender) ||
        voices.find(voice => voice.id === defaultVoiceByGender)
    );
};

export const getDefaultVoice = (presenter: Pick<Presenter, 'voice' | 'gender' | 'voice_id'>, voices: IVoice[]) => {
    let voice = getDefaultVoiceForPresenter(presenter, voices);

    if (!voice) {
        voice = getDefaultVoiceForGender(presenter?.gender, voices);
    }

    return voice || voices[0] || null;
};
